import React, { Component } from 'react';
import { Route } from 'react-router-dom';
// import { BrowserRouter as Router } from 'react-router-dom';
// import AppRouterAccess from './AppRouterAccess';

import Form from './pages/MainFormPost';
import Static from './pages/Static';
import Code from './pages/Code';

class App extends Component {
  render() {
    return (
      <>
        <Route exact path="/" component={Form} />
        <Route exact path="/code" component={Code} />
        <Route exact path="/static" component={Static} />
      </>
    );
  }
}

export default App;